module.exports = __webpack_public_path__ + "img/電気回路_2_2_1.34745ebb.png";